import styled from 'styled-components';
import RequestSmsSummary from './components/RequestSmsSummary';
import RequestSmsFilter from './components/RequestSmsFilter';
import useGetRequestSMSPurchase from '../../services/hooks/useGetRequestSMSPurchase';
import RequestSmsTable from './components/RequestSmsTable';
import useGetSummaryRequestSMS from '../../services/hooks/useGetSummaryRequestSMS';

const RequestSMSPurchasePage = () => {
  const { data, params, setParams } = useGetRequestSMSPurchase();
  const { data: summaryData, setParams: setSummaryParams } = useGetSummaryRequestSMS();

  return (
    <Container>
      <RequestSmsSummary data={summaryData} />
      <RequestSmsFilter params={params} setParams={setParams} setSummaryParams={setSummaryParams} />
      <RequestSmsTable data={data} params={params} setParams={setParams}/>
    </Container>
  );
};

export default RequestSMSPurchasePage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 1.5rem;
`;
